import { useTranslation } from "react-i18next";
import { formatNumber } from "utils/utils";

import InfoCircle from "../infoCircle";

const SeasonContent = ({ leagueData, userRoundData }) => {
  const { gameType, scoreRule, eliminatedCount, userCount } = leagueData;

  const { t } = useTranslation();
  return (
    <>
      {/* <swiper-slide> */}
      <div className="flex h-24 items-center justify-center space-x-4">
        <InfoCircle
          label={t("lobby.card.players", {
            count: userCount,
          })}
          value={userCount}
        />

        {userRoundData && (
          <InfoCircle
            label={t("lobby.card.points")}
            value={
              scoreRule == 2
                ? userRoundData.points.toFixed(1)
                : scoreRule == 6
                ? userRoundData.leaguePicks
                : userRoundData.points
            }
          />
        )}
        {userRoundData && (
          <InfoCircle
            label={t("lobby.card.place")}
            value={
              userRoundData && userRoundData?.pos
                ? formatNumber(userRoundData?.pos)
                : "-"
            }
          />
        )}
      </div>
      {/* </swiper-slide> */}
    </>
  );
};

export default SeasonContent;
